import { EndScreen, EndScreenConstructorParams } from './end-screen';
import { EndScreenType } from './end-screen-types';

export class EndScreenDefault extends EndScreen {
  constructor({ config }: EndScreenConstructorParams) {
    super({ config });
    this.type = EndScreenType.DEFAULT;
  }

  isValid(): boolean {
    return this.duration > 0;
  }
}
